module.exports = __webpack_public_path__ + "img/Art_Studio_N.7d492110.jpg";